<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Operadores</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataOperadores"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              v-if="permissaoTotal"
              dark
              color="orangePcm"
              href="/central-de-atendimento/cadastro/operador/criar"
              target="_blank"
              @click="handleGoToNewRamal"
              class="mr-2"
            >
              Criar Operador
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.queue`]="{ item }">
            <div>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-eye</v-icon>
                </template>
                <v-row no-gutters v-for="queue in item.queue" :key="`queue_name_${queue}`">
                  <span class="font-weight-bold">{{ queue }}</span>
                </v-row>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  :href="`/central-de-atendimento/cadastro/operador/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  @click="atualizarButton($event, item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <!--<v-switch
              v-model="item.active"
              dense
              @click.stop="activeInactiveOperator(item)"
              class="mb-n2 mt-2"
              :disabled="!permissaoEditar"
            />-->
            <div :class="`${getColor(item.active)}--text`">
              {{ `${ (item.active) ? 
                  `Ativo `: 
                  `Desativado`}` }}
            </div>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>
              Total de Operadores: {{ qtdOperadores }} / Ativos:
              {{ activeOperadores }} / Inativos:
              {{ inactiveOperadores }}
            </p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import operadoresStore from '../_store'
import operadorHttpService from '../_services/operadorHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    permissaoTotal: false,
    permissalEditar: false,
    headers: [
      {
        text: 'Operador',
        value: 'numero',
        align: 'left',
      },
      {
        text: 'Nome',
        value: 'usuario',
        align: 'left',
      },
      { 
        text: 'Filas', 
        align: 'center', 
        value: 'queue', 
        sortable: false, 
      },
      // {
      //   text: 'Email',
      //   value: 'email',
      //   align: 'left',
      //   sortable: false,
      // },
      {
        text: 'Status',
        value: 'active',
        align: 'left',
        sortable: false,
        width: 1,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataOperadores: [],
    arrayPermissaoTotal: [process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_TOTAL, process.env.VUE_APP_ADMINISTRADOR],
    arrayPermissaoEditar: [
      process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_TOTAL,
      process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_EDITAR_CONDICIONADO,
      process.env.VUE_APP_ADMINISTRADOR,
    ],
  }),

  computed: {
    ...mapGetters('operadoresHomeModuleCallCenterStore', ['getOperadores', 'getFilaById']),

    numberOfPages() {
      return Math.ceil(this.dataOperadores.length / this.itemsPerPage)
    },
    qtdOperadores() {
      return this.dataOperadores.length
    },
    activeOperadores() {
      return this.dataOperadores.filter(operador => operador.active).length || 0
    },
    inactiveOperadores() {
      return this.dataOperadores.filter(operador => !operador.active).length || 0
    },
  },

  async created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    arrayPermissions.forEach(permissaoLocalStorage => {
      if (this.arrayPermissaoTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true
      }
      if (this.arrayPermissaoEditar.includes(permissaoLocalStorage)) {
        this.permissaoEditar = true
      }
    })

    registerVuexModule(this.$store, 'operadoresHomeModuleCallCenterStore', operadoresStore)
    await Promise.all([this.listarOperadores(), this.listarFilas()])
    // await this.listarOperadores()
    // await this.listarFilas()

    this.dataOperadores = this.getOperadores.map( operadores => ({
      ...operadores,
      queue: operadores.queues.map(fila => this.getFilaById(fila.queue).description || ''),
    }))


    this.dataOperadores.splice(0, 1, this.dataOperadores[0])

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('operadoresHomeModuleCallCenterStore', ['listarOperadores', 'listarFilas']),
    ...obtainUserPermissions,

    getColor(active) {
      if (active == true ) {
        return 'font-weight-bold green'
      }else {
        return 'font-weight-bold red'
      }
    },

    handleGoToNewRamal(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewRamal = this.$router.resolve({ name: 'Operador/criar' })
        window.open(goToNewRamal.href, '_blank')
      } else {
        this.$router.push({ name: 'Operador/criar' })
      }
    },

    atualizarButton(event, item) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`operador/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`operador/atualizar/${item._id}`)
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`operador/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`operador/atualizar/${item.item._id}`)
      }
    },

    async activeInactiveOperator(item) {
      const indexArrayOperatorData = this.dataOperadores.findIndex(operador => operador._id === item._id)
      if (indexArrayOperatorData !== -1) {
        item.active = !item.active
        this.dataOperadores.splice(indexArrayOperatorData, 1, item)
        await operadorHttpService.putOperador(item._id, item)
      }
    },
  },
}
</script>
